import React, { useContext, useState } from "react";

//import context
import { MyContext } from "../../../../tenantsDashContext";

//import icons
import { RiMessage2Line } from "react-icons/ri";
import { LiaFileInvoiceSolid } from "react-icons/lia";
import { MdPayment } from "react-icons/md";
import { RxDashboard } from "react-icons/rx";
import { BiWallet } from "react-icons/bi"; // Added for the pay button
import { MdMobileScreenShare } from "react-icons/md";

//import css
import "./Mobile-Nav.scss";
import PayWindowModal from "../../Payments/Mobile-and-Tablet/PayWindowModal";

const MobileNav = () => {
  const { sharedValue, setSharedValue } = useContext(MyContext);
  const [activeNavItem, setActiveNavItem] = useState("Overview"); // Set the default active item

  const handleNavClick = (item) => {
    setActiveNavItem(item);
    setSharedValue(item);
    console.log("Shared Value:", sharedValue);
  };

  //modal variables
  const [showPay, setShowPay] = useState(false);

  return (
    <>
      <nav className="mobile-nav">
        <button onClick={() => handleNavClick("Overview")}>
          <div
            className={`nav-item ${
              activeNavItem === "Overview" ? "nav-item-active" : ""
            }`}
          >
            <RxDashboard size={24} />
            <span className="nav-text">Overview</span>
          </div>
        </button>

        <button onClick={() => handleNavClick("Payments")}>
          <div
            className={`nav-item ${
              activeNavItem === "Payments" ? "nav-item-active" : ""
            }`}
          >
            <MdPayment size={24} />
            <span className="nav-text">Payments</span>
          </div>
        </button>

        {/* Pay circular button */}
        <button
          className="pay-button"
          onClick={() => {
            setShowPay(true);
          }}
        >
          <div
            className={`pay-button-content ${
              activeNavItem === "Pay" ? "nav-item-active" : ""
            }`}
          >
            <BiWallet size={28} />
            <span className="nav-text">Pay</span>
          </div>
        </button>

        <button onClick={() => handleNavClick("Invoices")}>
          <div
            className={`nav-item ${
              activeNavItem === "Invoices" ? "nav-item-active" : ""
            }`}
          >
            <LiaFileInvoiceSolid size={24} />
            <span className="nav-text">Invoices</span>
          </div>
        </button>

        <button onClick={() => handleNavClick("Messages")}>
          <div
            className={`nav-item ${
              activeNavItem === "Messages" ? "nav-item-active" : ""
            }`}
          >
            <RiMessage2Line size={24} />
            <span className="nav-text">Messages</span>
          </div>
        </button>
      </nav>
      {showPay && (
        <>
          <div className="modal">
            <PayWindowModal setShowPay={setShowPay} fieldToShow={false} />
          </div>
        </>
      )}
    </>
  );
};

export default MobileNav;
